import gql from "graphql-tag";
const getFreeFormOraclesQuery = gql(` 
query getOraclesQuery($params: AWSJSON!) {
  getFreeFormOracle(params: $params) {
    id
    result
    profile
    nearest
  }
}
`)
export default getFreeFormOraclesQuery;
